import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="bg-sigma-black text-white animate-fade-in">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center mb-4 transition-transform duration-200 hover:scale-105">
              <img 
                src="/brand-assets/Sigma%20Pl%20-%20White.png" 
                alt="Sigma Immigration Logo" 
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-sigma-grey mb-6 font-hind text-sm">
              Your trusted partner for complete business and immigration solutions in Poland. We make the process simple and stress-free with professional guidance and comprehensive support.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/sigmaimmigration.pl" 
                target="_blank"
                rel="noopener noreferrer" 
                className="text-sigma-grey hover:text-white transition-all duration-300 hover:scale-110 transform"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a 
                href="https://www.facebook.com/share/16VKhUN264/?mibextid=wwXIfr" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-sigma-grey hover:text-white transition-all duration-300 hover:scale-110 transform"
                onClick={scrollToTop}
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a 
                href="https://x.com/sigmaimmigratio" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-sigma-grey hover:text-white transition-all duration-300 hover:scale-110 transform"
                onClick={scrollToTop}
              >
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="font-alumni text-lg font-bold mb-4 uppercase tracking-wide">Services</h3>
            <ul className="space-y-2 text-sigma-grey font-hind text-sm">
              <li><Link to="/consultation" onClick={scrollToTop} className="hover:text-white transition-colors duration-200 hover:scale-105 inline-block">Free Consultation</Link></li>
              <li><Link to="/services" onClick={scrollToTop} className="hover:text-white transition-colors duration-200 hover:scale-105 inline-block">Immigration Services</Link></li>
              <li><Link to="/contact" onClick={scrollToTop} className="hover:text-white transition-colors duration-200 hover:scale-105 inline-block">Business Services</Link></li>
              <li><Link to="/help-center" onClick={scrollToTop} className="hover:text-white transition-colors duration-200 hover:scale-105 inline-block">Support Services</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-alumni text-lg font-bold mb-4 uppercase tracking-wide">Support</h3>
            <ul className="space-y-2 text-sigma-grey font-hind text-sm">
              <li><Link to="/contact" onClick={scrollToTop} className="hover:text-white transition-colors duration-200 hover:scale-105 inline-block">Contact Us</Link></li>
              <li><Link to="/about" onClick={scrollToTop} className="hover:text-white transition-colors duration-200 hover:scale-105 inline-block">About Us</Link></li>
              <li><Link to="/knowledge-base" onClick={scrollToTop} className="hover:text-white transition-colors duration-200 hover:scale-105 inline-block">Knowledge Base</Link></li>
              <li><Link to="/help-center" onClick={scrollToTop} className="hover:text-white transition-colors duration-200 hover:scale-105 inline-block">Help Center</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-alumni text-lg font-bold mb-4 uppercase tracking-wide">Company Info</h3>
            <ul className="space-y-2 text-sigma-grey font-hind text-sm">
              <li>Registration: KRS: 0001095578</li>
              <li>NIP: 7011196128</li>
              <li>REGON: 528136297</li>
              <li>Warsaw, Poland</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-wrap gap-x-6 gap-y-2 justify-center md:justify-start">
              <Link to="/PrivacyPolicy" onClick={scrollToTop} className="text-sigma-grey hover:text-white text-sm transition-colors duration-200">Privacy Policy</Link>
              <Link to="/TermsOfService" onClick={scrollToTop} className="text-sigma-grey hover:text-white text-sm transition-colors duration-200">Terms of Service</Link>
              <Link to="/CookiePolicy" onClick={scrollToTop} className="text-sigma-grey hover:text-white text-sm transition-colors duration-200">Cookie Policy</Link>
              <Link to="/GDPRCompliance" onClick={scrollToTop} className="text-sigma-grey hover:text-white text-sm transition-colors duration-200">GDPR Compliance</Link>
            </div>
            
            <div className="text-right">
              <p className="text-sigma-grey text-sm font-hind">Trusted by thousands of clients</p>
              <p className="text-gray-500 text-xs mt-2">©2025 SkyHigh Ventures All Rights Reserved</p>
              <p className="text-gray-500 text-xs">All rights reserved. Licensed immigration consultancy.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
export { Footer };
